/**
 * Login page design tokens.
 *
 * Kept local rather than added to the app theme: the sign-in page is the one
 * surface with a dark, brand-led look, and the dashboard's palette should not
 * pick these up by accident.
 */
export const LOGIN = {
  navy: '#07152F',
  navyDeep: '#050F24',
  indigo: '#1B1F5E',
  panelText: '#E6EEFB',
  panelMuted: '#9FB0CC',
  panelFaint: '#6F82A3',
  cyan: '#38D5F5',
  blue: '#3B82F6',
  green: '#22C55E',
  card: '#FFFFFF',
  cardInk: '#0B1B3A',
  cardMuted: '#5B6B86',
  cardFaint: '#8A99B2',
  hairline: 'rgba(15, 23, 42, 0.08)',
  font: '"Inter", "Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  hand: '"Caveat", "Segoe Script", "Bradley Hand", cursive',
} as const;
